import React from 'react';

interface RedirectSpinnerProps {
  message?: string; // main heading (e.g., Redirecting...)
  subMessage?: string; // descriptive line below
  className?: string;
}

// Centralized spinner used across payment linking / settings flows
export const RedirectSpinner: React.FC<RedirectSpinnerProps> = ({
  message = 'Redirecting...',
  subMessage = 'Please do not close or refresh the window, we are redirecting you to link the payment selected.',
  className = ''
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center py-8 ${className}`}
    >
      <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-green-500" />
      <p className="text-md text-center font-medium text-green-600">
        {message}
      </p>
      <p className="mt-4 px-4 text-center text-xs leading-relaxed text-gray-600">
        {subMessage}
      </p>
    </div>
  );
};

export default RedirectSpinner;
